import { EnsoMark } from "@/components/Logo";

const items = [
  "Web design",
  "Development",
  "AI tools",
  "SEO foundations",
  "Social media",
  "Lead generation",
  "Care plans",
];

const Row = ({ hidden }) => (
  <div
    aria-hidden={hidden || undefined}
    className="flex shrink-0 items-center"
  >
    {items.map((item) => (
      <span key={item} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-display text-xl font-light italic text-jade sm:text-2xl">
          {item}
        </span>
        <EnsoMark className="h-3 w-3 shrink-0 text-jade/50" />
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <div
    className="overflow-hidden border-y border-jade/10 bg-paper2 py-5"
    data-testid="marquee-band"
  >
    <div className="marquee-track flex w-max">
      <Row />
      <Row hidden />
    </div>
  </div>
);

export default Marquee;